<template>
	<div class="display-container">
		<div class="display">
			<p class="display-title">基本信息</p>
			<div class="display-date">
				<p class="display-date-title">
					新版报告：
				</p>
				<el-switch class="display-date-switch" v-model="newReportSwitchEnabled" active-color="#6DA4D8"
					inactive-color="#DCDFE6" disabled>
				</el-switch>

			</div>
			<div class="display-report">
				<p class="display-report-title">报告抬头：</p>
				<p class="display-report-content">{{ this.reportTitle }}</p>
			</div>
			<div class="display-subtitle">
				<p class="display-subtitle-title">二级标题：</p>
				<p class="display-subtitle-content">{{ this.reportSubTitle }}</p>
			</div>
			<div class="display-sign">
				<p class="display-sign-title">默认报告签名：</p>
				<el-switch class="display-sign-switch" v-model="sopReportSign" active-color="#6DA4D8"
					inactive-color="#DCDFE6" disabled>
				</el-switch>
				<p class="display-sign-name">{{ this.sopReportSignValue }}</p>
			</div>
			<div class="display-date">
				<p class="display-date-title">
					默认签名日期：
				</p>
				<el-switch class="display-date-switch" v-model="sopReportSignDate" active-color="#6DA4D8"
					inactive-color="#DCDFE6" disabled>
				</el-switch>

			</div>
			<icon-unit class="display-middle-right" :iconType="'noTitle'" iconKey="睡眠初筛报告Logo"
				:iconURL="reportLogo"></icon-unit>
		</div>

		<!-- 报告组成部分 -->
		<div class="display" v-if="newReportSwitchEnabled">
			<p class="display-title">报告组成</p>


			<!-- 血氧脉率报告 -->
			<div class="display-date" v-if="spo2PulseReportSwitch">
				<p class="display-date-title">血氧脉率报告：</p>
				<el-switch class="display-date-switch" v-model="spo2PulseReportSwitch" active-color="#6DA4D8"
					inactive-color="#DCDFE6" disabled>
				</el-switch>
			</div>

			<div class="display-module-config" v-if="spo2PulseReportSwitch">
				<p class="display-module-title">模块配置：</p>
				<div class="display-module-tags">
					<span v-for="module in spo2PulseModuleConfig" :key="module" class="module-tag">
						{{ module }}
					</span>
				</div>
			</div>

			<div class="display-subtitle" v-if="spo2PulseReportSwitch">
				<p class="display-subtitle-title">二级标题：</p>
				<p class="display-subtitle-content">{{ this.spo2PulseSecondaryTitle }}</p>
			</div>

			<!-- 睡眠结构报告 -->
			<div class="display-date" v-if="sleepStructureSwitch">
				<p class="display-date-title">睡眠结构报告：</p>
				<el-switch class="display-date-switch" v-model="sleepStructureSwitch" active-color="#6DA4D8"
					inactive-color="#DCDFE6" disabled>
				</el-switch>
			</div>

			<div class="display-module-config" v-if="sleepStructureSwitch">
				<p class="display-module-title">模块配置：</p>
				<div class="display-module-tags">
					<span v-for="module in sleepStructureModuleConfig" :key="module" class="module-tag">
						{{ module }}
					</span>
				</div>
			</div>

			<div class="display-subtitle" v-if="sleepStructureSwitch">
				<p class="display-subtitle-title">二级标题：</p>
				<p class="display-subtitle-content">{{ this.sleepStructureSecondaryTitle }}</p>
			</div>

		</div>
	</div>

</template>

<script>
import IconUnit from "@c/setting/organization-configuration/display/icon-unit.vue";
export default {
	components: {
		IconUnit,
	},
	props: {
		model: Object,
		newReportSwitchEnabled: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			sopReportSign: false,
			sopReportSignDate: false,
			sopReportSignValue: "",

			reportTitle: "",
			reportSubTitle: "",
			reportLogo: "",
			isNewReport: true,

			// 报告组成相关数据
			sleepStructureSwitch: false,
			sleepStructureModuleConfig: [],
			sleepStructureSecondaryTitle: "",
			spo2PulseReportSwitch: false,
			spo2PulseModuleConfig: [],
			spo2PulseSecondaryTitle: "",
		}
	},

	created() {
		this.initValue()
		console.log('this.newReportSwitchEnabled', this.newReportSwitchEnabled)
	},
	computed: {

	},

	methods: {
		initValue() {

			if (this.model.sopReportSignDate == null || this.model.sopReportSignDate == "0") {
				this.sopReportSignDate = false;

			} else {
				this.sopReportSignDate = true;

			}

			if (this.model.sopReportSign == null || this.model.sopReportSign == "") {
				this.sopReportSign = false;
				this.sopReportSignValue = "";
			} else {
				this.sopReportSign = true;
				this.sopReportSignValue = this.model.sopReportSign;
			}
			this.reportTitle = this.model.sopReportHeaders
			this.reportSubTitle = this.model.sopReportSubTitle
			this.reportLogo = this.model.sopReportLogo

			// 初始化报告组成数据
			this.sleepStructureSwitch = !!this.model.sleepStructureSwitch;
			// 解析字符串为数组
			try {
				this.sleepStructureModuleConfig = typeof this.model.sleepStructureModuleConfig === 'string'
					? JSON.parse(this.model.sleepStructureModuleConfig)
					: (Array.isArray(this.model.sleepStructureModuleConfig) ? this.model.sleepStructureModuleConfig : []);
			} catch (e) {
				this.sleepStructureModuleConfig = [];
			}
			this.sleepStructureSecondaryTitle = this.model.sleepStructureSecondaryTitle || "";

			this.spo2PulseReportSwitch = !!this.model.spo2PulseReportSwitch;
			// 解析字符串为数组
			try {
				this.spo2PulseModuleConfig = typeof this.model.spo2PulseModuleConfig === 'string'
					? JSON.parse(this.model.spo2PulseModuleConfig)
					: (Array.isArray(this.model.spo2PulseModuleConfig) ? this.model.spo2PulseModuleConfig : []);
			} catch (e) {
				this.spo2PulseModuleConfig = [];
			}
			this.spo2PulseSecondaryTitle = this.model.spo2PulseSecondaryTitle || "";
		}
	},

	watch: {
		model(newValue) {

			if (newValue.sopReportSignDate == "1") {
				this.sopReportSignDate = true;

			} else {
				this.sopReportSignDate = false;

			}

			if (newValue.sopReportSign == null || newValue.sopReportSign == "") {
				this.sopReportSign = false;
				this.sopReportSignValue = "";
			} else {
				this.sopReportSign = true;
				this.sopReportSignValue = newValue.sopReportSign
			}
			this.reportTitle = newValue.sopReportHeaders
			this.reportSubTitle = newValue.sopReportSubTitle
			this.reportLogo = newValue.sopReportLogo

			// 更新报告组成数据
			this.sleepStructureSwitch = !!newValue.sleepStructureSwitch;
			// 解析字符串为数组
			try {
				this.sleepStructureModuleConfig = typeof newValue.sleepStructureModuleConfig === 'string'
					? JSON.parse(newValue.sleepStructureModuleConfig)
					: (Array.isArray(newValue.sleepStructureModuleConfig) ? newValue.sleepStructureModuleConfig : []);
			} catch (e) {
				this.sleepStructureModuleConfig = [];
			}
			this.sleepStructureSecondaryTitle = newValue.sleepStructureSecondaryTitle || "";

			this.spo2PulseReportSwitch = !!newValue.spo2PulseReportSwitch;
			// 解析字符串为数组
			try {
				this.spo2PulseModuleConfig = typeof newValue.spo2PulseModuleConfig === 'string'
					? JSON.parse(newValue.spo2PulseModuleConfig)
					: (Array.isArray(newValue.spo2PulseModuleConfig) ? newValue.spo2PulseModuleConfig : []);
			} catch (e) {
				this.spo2PulseModuleConfig = [];
			}
			this.spo2PulseSecondaryTitle = newValue.spo2PulseSecondaryTitle || "";
		}
	}
};
</script>

<style lang="scss" scoped>
.display-container {
	display: flex;
	flex-direction: column;
	gap: rem(24);

	.display {
		background-color: white;
		width: 100%;
		position: relative;
		padding: rem(16);
		border-radius: rem(8);

		&-title {
			color: black;
			font-size: rem(16);
			font-weight: bold;
			height: rem(22);
			margin-top: rem(16);
		}

		&-report {
			&-title {
				width: rem(70);
			}

			display: flex;
			margin-top: rem(18);
			color: black;
			font-size: rem(14);
		}

		&-subtitle {
			&-title {
				width: rem(70);
			}

			display: flex;
			margin-top: rem(18);
			color: black;
			font-size: rem(14);
		}

		&-sign {
			margin-top: rem(20);
			display: flex;
			align-items: center;
			font-size: rem(14);
			color: black;


			&-title {
				width: rem(108);

			}

			&-switch {
				transform: scale(1.3);
				margin-left: rem(6);

			}

			&-name {
				margin-left: rem(26);
			}
		}

		&-date {
			margin-top: rem(20);
			display: flex;
			align-items: center;
			font-size: rem(14);
			color: black;


			&-title {
				width: rem(108);

			}

			&-switch {
				transform: scale(1.3);
				margin-left: rem(6);

			}

			&-date {
				margin-left: rem(26);
			}
		}

		// 模块配置样式
		&-module-config {
			margin-top: rem(18);

			.display-module-title {
				color: black;
				font-size: rem(14);
				margin-bottom: rem(8);
			}

			.display-module-tags {
				display: flex;
				flex-wrap: wrap;
				gap: rem(8);

				.module-tag {
					background-color: #f0f2f5;
					color: #333;
					padding: rem(4) rem(8);
					border-radius: rem(4);
					font-size: rem(12);
					border: 1px solid #d9d9d9;
				}
			}
		}
	}
}
</style>